/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Refused_LicenseInputs */

const vi_einvoice_stuck_refused_license = /** @type {(inputs: Einvoice_Stuck_Refused_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói hóa đơn MISA đã hết hạn hoặc hết lượt. Báo quản trị.`)
};

/**

* @param {Einvoice_Stuck_Refused_LicenseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_refused_license = /** @type {((inputs?: Einvoice_Stuck_Refused_LicenseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Refused_LicenseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_refused_license(inputs)
});